import {FilterLanguage} from "../../nddUtils/filterLanguage.service";

import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {BriefResultService} from './briefResult.service';
import {SearchService} from '../search.service';
import {PrimoResponse} from '../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {encodeZoteroValue} from '../../nddUtils/zoteroUtil';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';
import {FilterInstitution} from '../../nddUtils/filterInstitution.service'
import {ChangeLangService} from "../../infra/lang/changeLang.service";
import {FullViewPageService} from "../fullView/fullViewPage/fullViewPage.service";
import {STATE_NAMES} from "../../primoExplore/primoExploreStates.module";
import {PrimolyticsService, beacon} from '../../analytics/primolytics.service';
import {isBrowserIE} from "../../infra/browserSniffer";
import {marcSubFields} from '../../infra/constants';
import { AuthoritySearchService } from "../authority/authoritySearch.service";

const findIndex = require('lodash/findIndex');
const getValue = require('lodash/get');
const isEqual = require('lodash/isEqual');

@Component({
    providers: [],
    "selector": "prm-brief-result",
    templateUrl: 'components/search/briefResult/briefResult.html'
})

export class PrmBriefResult implements OnInit {
    @Input() item: PrimoResponse.IDoc;
    @Input() rtaInProgress: boolean;
    @Input() resourceTypeForDisplay: string;
    @Input() deepLink: string;
    @Input() isFullView: boolean;
    @Input() isCollectionDiscoveryCollection: boolean;
    @Input() displayMode: string;
    private lines: string[];
    private lastId: number;
    private showItemType: boolean = !this.isServicesPageState();
    private firstLine;
    private otherLines;
    private isIe = isBrowserIE();
    private isAuthoritySearch: boolean = false;

    private KEY_CODE = {
        COMMA: 188,
        SEMICOLON: 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW: 37,
        UP_ARROW: 38,
        RIGHT_ARROW: 39,
        DOWN_ARROW: 40,
        TAB: 9,
        BACKSPACE: 8,
        DELETE: 46
    };



    constructor(private briefResultService: BriefResultService,
                private searchService: SearchService,
                private configurationUtil: ConfigurationUtil,
                private filterInstitution: FilterInstitution,
                private filterLanguage: FilterLanguage,
                private fullViewPageService: FullViewPageService,
                private primolyticsService: PrimolyticsService,
                @Inject('$state') private $state,
                @Inject('$location') private $location: ng.ILocationService,
                private changeLangService: ChangeLangService,
                private authoritySearchService: AuthoritySearchService) {
                this.isAuthoritySearch = this.authoritySearchService.isAuthorityState();
                }

    private combiningHalfMarksRegexp = new RegExp('(.[\uFE20-\uFE2F].[\uFE20-\uFE2F])', 'gi');

    ngOnInit() {
        this.lastId = -1;
        this.item.pnx = this.filterLanguage.fillterPnx(this.item.pnx, this.isAuthoritySearch);
        this.getDisplayLines().then((lines) => {
            this.firstLine = lines.shift();
            this.otherLines = lines;
        });
    }

    async getDisplayLines() {
        if (!this.item) {
            return [];
        }
        let pnxId = this.item.pnx.display.source;
        if (!this.lines || this.lastId !== pnxId) {
            this.lastId = pnxId;
            this.lines = await this.briefResultService.parseDisplayLines(this.item, this.isCollectionDiscoveryCollection);
        }
        return this.lines;
    }

    private isServicesPageState() {
        return this.briefResultService.isServicePageState();
    }

    private  calcZoteroParams() {

        if (!getValue(this.item,'delivery.link')) {
            return;
        }
        let openUrlIndex = findIndex(this.item.delivery.link, (link)=>link.linkType.indexOf('openurl') > -1);
        if (openUrlIndex > -1) {
            let openUrl: string = this.item.delivery.link[openUrlIndex]['linkURL'];
            return encodeZoteroValue(openUrl);
        }
    }

    get zoteroParamsString() {
        return this.calcZoteroParams();
    }

    get highlights() {
        return this.searchService.highlightsService.highlights;
    }

	includesSubFieldsWithDollar(value){
		let includes = false;
		for (let i=0;i< marcSubFields.length;i++){
			if (value.includes(marcSubFields[i])){
				includes = true;
				break;
			}
		}
		return includes;
	}
	
    getDisplayValFromVal(value, delimiter, key) {
        let finalVal = '';
        let ignoreMap = {'crsinfo': '$$V'};
        if (key !== undefined && ignoreMap[key] !== undefined) {
            let replaceWhat = ignoreMap[key];
            let replaceTo = replaceWhat + this.briefResultService.defaultDelimiter;
            //replace function doesn't work here good enough - better and simpler with split and join
            value = value.split(replaceWhat).join(replaceTo);
        }
        if (this.includesSubFieldsWithDollar(value) || (isEqual(key, 'relation'))) {
            if (value.includes(this.briefResultService.defaultDelimiter)) {
                value.split(this.briefResultService.defaultDelimiter).forEach((val, i)=> {
                    if (!(val.split('$$')[0] === '' && i === 0) && val.trim() !== '') {
                        finalVal += val.split('$$')[0] + delimiter;
                    }
                });
            } else {
                finalVal = value.split('$$')[0];
            }
            return finalVal.endsWith(delimiter) ? finalVal.substr(0, finalVal.length - delimiter.length) : finalVal;
        }

        if (delimiter && value.endsWith(delimiter.trim()) && delimiter.trim().length != 0) {
            return value.substr(0, value.length - 1)
        }

        return value;
    }

    public filterAndNormalize(text) {
        return this.filterInstitution.filterAndNormalizeData(text, text);
    }

    public getFirstLineKeyByIndex(index) : string {
        return getValue(this.firstLine, `values[${index}].key`);
    }
    
    public isEmailMode() {
        return this.displayMode === 'email';
    }


    getClassForIdentifier() {
        if (this.configurationUtil.isSuprima()) {
            if (this.$state.params.rft_dat && this.$state.params.rft_dat.toLowerCase().indexOf('ie=') > -1) {
                return 'identifier-in-brief-local';
            } else {
                return 'identifier-in-brief-classic';
            }
        }

        return '';
    }

    get logTimeStamp() {
        window.appPerformance.timeStamps['search result displayed'] = Date.now();
        return '';
    }


    get logTimeStampFull() {
        window.appPerformance.timeStamps['search result displayed full view'] = Date.now();
        return '';
    }
    getResourceTypeForDisplay() {
        if(this.isAuthoritySearch){
            return;
        }
        return (this.searchService.getFrbrDisplay() === 1 ? 'mediatype.multiplever' : 'mediatype.' + this.item.pnx.display.type[0]);
    }


    private changeStringDirectionToRtl(strArray) {
        return this.briefResultService.changeStringDirectionToRtl(strArray);
    }

    get isFullViewOverlayOpen(){
        return this.briefResultService.isFullViewOverlayOpen;
    }

    private getPnxInXmlUrl(){
        return this.briefResultService.ShowPnxInXmlUrl(this.item);
    }

    // @HostListener('keydown', ['$event'])
    private keydownSupport(e) {
        let keyCodes = this.KEY_CODE;

        if (e.keyCode === keyCodes.ENTER) {
            e.stopPropagation();
            return this.deepLink;
        }
    }

    hl(field){
        if(this.highlights) {
            let res = this.highlights[field];
            if (res) {
                return res;
            }
            else {
                return this.highlights.termsUnion;
            }
        }else {
            return '';
        }
    }

    private getTextDirection(text) {
        return this.briefResultService.getTextDirection(text);
    }

    private isChaptersAndReviewsState() {
        return this.$state.current.name == STATE_NAMES.CITATION_CHAPTERS;
    }

    private getZoteroClassName() {
        if(this.isFullViewOverlayOpen){
            return 'urlToXmlPnxSingleRecord';
        }else{
            return 'urlToXmlPnx';
        }        
    }

    
    get recordId() {
        return this.item.pnx.control.recordid[0];
    }    

    get authorityHeading() {
        return this.item.pnx.display.heading[0];
    }    
    
    public sendBeacon(){
        if(this.$state.current.name === STATE_NAMES.SEARCH && !this.$location.path().endsWith('/fulldisplay')){
            this.runBriefTitleBeaconCall();
        }
    }


    public addRecordOnScrollMouseClick(event: MouseEvent) {
        if(event.button === 1)
            this.searchService.fullViewService.addRecordToRemoteRecordTable(this.item);
    }

    public addRecordOnContextMenu(event: MouseEvent | KeyboardEvent) {
        this.searchService.fullViewService.addRecordToRemoteRecordTable(this.item);
    }
    
    @beacon({'p': 'brief', 'op': 'title'})
    public runBriefTitleBeaconCall() {}
    
}






// WEBPACK FOOTER //
// ./src/main/webapp/components/search/briefResult/briefResult.directive.ts